import React from "react";
import { GetIcon, GetNavLink, EventRouteDetails } from "../../config";
import { LocalizationConfig } from "@draftkings/sportsbook-common-contracts";

const getComponentDefaultValue = () => <></>
const getNavLinkDefaultValue = (props: React.PropsWithChildren<EventRouteDetails>) => (<>{props.children}</>)
const getOpenEarlyExitTagModalDefaultValue = () => undefined;
export interface SportsbookContextProps {
    getIcon: GetIcon;
    dictionary: LocalizationConfig;
    getNavLink: GetNavLink;
    openEarlyExitTagModal: () => void;
}


const createDefaultContext = (): SportsbookContextProps => ({
    getIcon: getComponentDefaultValue,
    dictionary: {} as LocalizationConfig,
    getNavLink: getNavLinkDefaultValue,
    openEarlyExitTagModal: getOpenEarlyExitTagModalDefaultValue
});

export const defaultValue: SportsbookContextProps = createDefaultContext();

export const SportsbookContext = React.createContext<SportsbookContextProps>(createDefaultContext());
